import {
  stringify,
  ParsedQuery as PermissionSetQueryParams,
} from 'query-string';
import { HttpClient } from 'api/http-client';
import {
  CreateCustomPermissionSetPayload,
  PermissionSetDefinition,
  PermissionSetDefinitionsLight,
  UpdatePermissionSetPayload,
} from './rbac-types';

class RbacHttpClient extends HttpClient {
  public getPermissionSetDefinitions = async (
    queryParams: PermissionSetQueryParams = {},
  ): Promise<Array<PermissionSetDefinition>> => {
    return this.get<Array<PermissionSetDefinition>>(
      `/permission-set/get-definition?${stringify(queryParams)}`,
    );
  };

  public getPermissionSetDefinitionsLight = async (): Promise<
    Array<PermissionSetDefinitionsLight>
  > => {
    return this.get<Array<PermissionSetDefinitionsLight>>(
      '/permission-set/get-definition-light',
    );
  };

  public createCustomPermissionSet = async (
    data: CreateCustomPermissionSetPayload,
  ): Promise<Array<PermissionSetDefinition>> => {
    return this.post('/permission-set/custom-permission-set', data);
  };

  public updatePermissionSet = async (
    data: UpdatePermissionSetPayload | UpdatePermissionSetPayload[],
  ): Promise<any> => this.put('/permission-set/custom-permission-set', data);
}

export const RbacApi = new RbacHttpClient();
